import { Link } from "react-router-dom";

const SearchResults = ({
  results,
  onResultClick,
  query = "",
  isLoading = false,
  style = {},
}) => {
  const normalizedQuery = query.trim().toLowerCase();
  const minCharsPending = query.trim().length > 0 && query.trim().length < 2;

  const highlightQuery = (value = "") => {
    if (!normalizedQuery || normalizedQuery.length < 2) return value;
    const text = String(value);
    const index = text.toLowerCase().indexOf(normalizedQuery);
    if (index === -1) return text;
    const before = text.slice(0, index);
    const match = text.slice(index, index + normalizedQuery.length);
    const after = text.slice(index + normalizedQuery.length);
    return (
      <>
        {before}
        <mark className="search-results__mark">{match}</mark>
        {after}
      </>
    );
  };

  const renderContent = () => {
    if (minCharsPending) {
      return (
        <div className="search-results__message">
          <i className="ph ph-keyboard text-4xl text-gray-300 mb-10 d-block" />
          <p className="text-gray-700 fw-semibold mb-4">
            Type at least 2 letters
          </p>
          <p className="text-gray-500 text-sm mb-0">
            We will suggest matching products instantly.
          </p>
        </div>
      );
    }

    if (isLoading) {
      return (
        <div className="search-results__loading">
          <div className="search-results__spinner" />
          <p className="text-gray-600 fw-medium mb-0">
            Finding the freshest matches...
          </p>
        </div>
      );
    }

    if (results.length === 0) {
      return (
        <div className="search-results__message">
          <i className="ph ph-magnifying-glass text-gray-300 text-5xl mb-12 d-block" />
          <p className="text-gray-700 fw-semibold mb-4">No products found</p>
          <p className="text-gray-500 text-sm mb-0">
            Try another keyword like tuna, prawns or crab.
          </p>
        </div>
      );
    }

    return (
      <div className="search-results__list">
        {results.map((product) => {
          const variant = product.product_variants?.[0] || {};
          return (
            <Link
              key={product.id}
              to={`/product-details/${product?.slug}`}
              className="search-results__item"
              onClick={onResultClick}
            >
              <img
                src={variant.product_image}
                alt={variant.title}
                className="search-results__image"
              />
              <div className="search-results__body">
                <h6 className="search-results__title">
                  {highlightQuery(variant.title)}
                </h6>
                <div className="search-results__meta">
                  <span className="search-results__price">
                    ₹{variant.sale_price}
                  </span>
                  <span className="search-results__chip">Fresh Cut</span>
                </div>
              </div>
              <i className="ph ph-arrow-up-right search-results__arrow" />
            </Link>
          );
        })}
      </div>
    );
  };

  return (
    <div
      className="search-results"
      style={{
        top: "100%",
        zIndex: 1000,
        ...style,
      }}
    >
      <div className="search-results__header">
        <p className="search-results__header-title mb-0">Suggestions</p>
        <span className="search-results__header-count">{results.length}</span>
      </div>
      {renderContent()}
    </div>
  );
};

export default SearchResults;
